const info =[
    {
        head:'ENFP',
        difficult: 'ISTJ',
        body:`Communication is the key for this relation to thrive. Don't assume one thing or another about the other person. ISTJ may attempt to mold the ENFP slowly into how they want to interact (logical, structured) so the ENFP must be sure not to feel burdened by this as to not compromise your behaviour – ENFP's passion brings tremendous value to any room `
    },
    {
        head:'ENTP',
        difficult: 'ISTJ',
        body:`This pairing boils down to values and self-awareness – because ISTJs are not typically quick thinkers and can be quite slow to appreciate the ENTP’s outside the box thinking. ISTJ will insist on doing things the right way and being thorough, which the lightening fast ENTP can dislike.`
    },
    {
        head:'ENTP',
        difficult: 'ISFJ',
        body:`Opposites attract – This can be seen as 'chaos v order' and can work well to balance each other out. Although, ISFJs who won’t argue and merely stand on their personal principles will annoy the ENTP.`
    },
    {   head:'ISFJ',
        difficult:'ENTJ',
        body:`ISFJ's carefully pick out a birthday presents with consideration while an ENTJ will run into a situation and figure it out as they go. This sums out this pairing.`
    },
    {
        head:'ISTP',
        difficult:'ENFJ',
        body:`The ENFJ will be the emotional beacon to bring the ISTP down to reality and realize their actions and behaviors, of which the ISTP will deeply defend with their objective reasoning. Quickly move past issues that are just differences in value – an ENFJ will grow upset by the bluntness of the ISTP. The ENFJ should not force their help onto others.`
    },
    {
        head:'ISFP',
        difficult:'ENTJs',
        body:`A pair that is great at recognizing each others' abilities; the ENTJ can be an encouraging and empathetic counterpart which can come across as a earful for the ISFP but they need and love someone to hype themselves up.`
    },
    {
        head:'ESFP',
        difficult:'ISTJ',
        body:`ESFPs are the happiest when they are having fun and getting others to let go. While ISTJ's will have a hard time letting go of their internal/external structure and order, both can feel they are being authentic and see each other's side.`
    },
    {
        head:'ESTJ',
        difficult:'INFP',
        body:`All with good intention; This pairing will question each other's motives, each fiercly defending their own points with solid reason. The ESTJ strives for the INFP to feel secure and is heavily rooted in reality while the imaginative INFP may struggle see reality from their counterparts' perspective.`
    },
    {
        head:'ESTP',
        difficult:'Other types',
        body:`ESTPs essentially get along with everyone given their enthusiasm and energy meter often being full. But watch out! – anyone who restricts their freedom will get a look of disapproval...`
    },
    {
        head:'ESFJ',
        difficult:'INTJ',
        body:'Cognitive functions are in reverse here and so both parties will have to recognize the differences: To the ESFJ, the INTJ can come across as having an icy demeanor with the answers to all the questions. Begin to build a language where both can feel they are on the same page'
    },
    {
        head:'INTJ',
        difficult:'Other types',
        body:`INTJs tap into their subconscious and are guided by their creative, instinctual abilities. Therefore, they comprehend things differently and will see things in a different light than most extraverted thinkers. INTJs may see all other types as sparrows – all over the place and entertaining, but also gullible.`
    },
    {
        head:'INTP',
        difficult:'ESFP, INFP, ISFP',
        body:`Introverted feelers are a likely fuse for the INTPs rasied temper. The INTP has difficulty seeing the importance placed on feeling, often seeing it as an irrational.`
    },
    {
        head:'ESFJ',
        difficult:'INTP',
        body:`An INTP and ESFJ will walk down a street and the INTP will not have recognized half as much as the ESFJ. Having said that, an INTP can pump out ideas quickly while the ESFJ needs to mull on the topic.`
    },
    {
        head:'ENTJ',
        difficult:'ENTP',
        body:`To some extent, everyone is an enemy to an ENTJ. In extreme cases, people are like pawns or obstacles. As far as the most competent obstacle, ENTPs can get in their way with slippery arguments and clever tactics.`
    },
    {
        head:'INFJ',
        difficult:'ENTJ',
        body:`The Golden Labrador Retriever; they have a love for humanity, understand humanity, and help humanity. Sometimes, however, types like the ENTJ, who can naturally forward their own interests at the expense of others, can be a pain in the back.`
    },
    {
        head:'INFP',
        difficult:'ESTJ',
        body:`Drawn together by differences. INFPs love stories, fantasies, poems, and all the impractical fantasies of the world. ESTJs are rather the opposites in nature – obsessive practicality, rational, and present-focused which can damper the INFPs creative mood – not allowing them space or not offering encouragement.`
    },

]

export {info}
